// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__l5DkF","title":"styles_title__2xXvH","content":"styles_content__paBNT"};